import { render, staticRenderFns } from "./ConfigurableProduct.vue?vue&type=template&id=a8aed672&scoped=true&"
import script from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
export * from "./ConfigurableProduct.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurableProduct.vue?vue&type=style&index=0&id=a8aed672&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8aed672",
  null
  
)

export default component.exports